
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_contact",
      function () {
        return require("private-next-pages/_contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_contact"])
      });
    }
  